import { useState } from 'react'
import { Button } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { primary_color } from '../../../Helper/uiHelper'
import { getCookie } from '../../../Helper/cookieHelper'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'

/**
 * School Years → Codes: queue 2-sheet Excel export into Downloads (same as CMS export).
 */
const ExportYearCodesButton = ({ gridRelatedData, disabled }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const globalSearchValue = useSelector((state) => state.Page.globalSearchValue)

  const buildPayload = () => {
    const yearId = currentRow?.[currentRow?.length - 1]?.id
    const payload = {
      ...(gridRelatedData?.initialPayload || {}),
      ...(gridRelatedData?.gridFilters || {}),
      parent_table_row_id: yearId,
      item_date_time_id: yearId,
      page_name: gridRelatedData?.pageName || 'codes_items',
      template_name: gridRelatedData?.page_data?.template_name || 'locker_years',
      grid_id: gridRelatedData?.mainGrid?.id,
      cms_key:
        gridRelatedData?.currentTabData?.cms_tab_key ||
        gridRelatedData?.mainGrid?.cms_tab_key ||
        gridRelatedData?.page_data?.cms_header_name ||
        gridRelatedData?.page_data?.cms_header_key,
    }
    if (globalSearchValue) {
      payload['-global-search'] = globalSearchValue
    }
    return payload
  }

  const run = () => {
    const yearId = currentRow?.[currentRow?.length - 1]?.id
    if (!yearId) {
      dispatch(setNotification({ type: 'error', message: 'Open a school year first' }))
      return
    }

    setLoading(true)
    const token = getCookie('AUTH_TOKEN')
    fetch(`${process.env.REACT_APP_API_URL}/automatic-codes/export-year-codes`, {
      method: 'POST',
      headers: {
        authorization: token && token !== 'undefined' ? `Bearer ${token}` : 'Bearer token',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(buildPayload()),
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}))
        if (!response.ok || data?.success === false) {
          throw new Error(data?.message || 'Export failed')
        }
        dispatch(
          setNotification({
            type: 'success',
            message: data?.message || 'Check download process in download section.',
          })
        )
        dispatch(fetchUpdateApiData(false))
      })
      .catch((err) => {
        dispatch(setNotification({ type: 'error', message: err?.message || 'Export failed' }))
      })
      .finally(() => setLoading(false))
  }

  return (
    <Button
      className='subtitle1 mb-2 mr-2'
      disabled={disabled || loading}
      style={{ background: primary_color, border: 'none' }}
      onClick={run}>
      {loading ? 'Queuing…' : 'Export Data'}
    </Button>
  )
}

export default ExportYearCodesButton
